import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as en from '../../locales/en';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { ...en },
    },
    lng: 'en',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    returnObjects: true,
    react: {
      wait: true,
    },
  });

export default i18n;
